import {
  ITableWithDraggableRowsColumn,
  removeSecondsFromFullTime,
} from '@repo/ui';
import { GetAllSemestersFromEntityUseCaseInterface } from 'domain/usecases';

export const makeSemestersFromEntityListColumns =
  (): ITableWithDraggableRowsColumn<
    GetAllSemestersFromEntityUseCaseInterface.Result[number]
  >[] => {
    return [
      {
        header: 'Nome',
        key: 'name',
      },
      {
        header: 'Turno',
        key: 'shift',
      },
      {
        header: 'Horário inicial',
        key: 'startingTime',
        render: (row) => removeSecondsFromFullTime(row.startingTime),
      },
      {
        header: 'Horário final',
        key: 'finishingTime',
        render: (row) => removeSecondsFromFullTime(row.finishingTime),
      },
    ];
  };
